export default __webpack_public_path__ + "static/media/evaluationFinish.2dd4ee1f.svg";